import { ErrorCircle20Regular, Warning20Regular } from "@fluentui/react-icons";
import { type CSSProperties, useSyncExternalStore } from "react";
import { createPortal } from "react-dom";
import { TOAST_TIMING, toastQueue } from "$/utils/toast";
import styles from "./index.module.css";

const timingStyle = {
	"--toast-fade-duration": `${TOAST_TIMING.fade}ms`,
} as CSSProperties;

export const ToastViewport = () => {
	const { notification, phase } = useSyncExternalStore(
		toastQueue.subscribe,
		toastQueue.getSnapshot,
		toastQueue.getSnapshot,
	);

	return createPortal(
		<div
			className={styles.viewport}
			style={timingStyle}
			role={notification?.type === "error" ? "alert" : "status"}
			aria-live={notification?.type === "error" ? "assertive" : "polite"}
			aria-atomic="true"
		>
			{notification && (
				<div
					key={notification.id}
					className={styles.toast}
					data-type={notification.type}
					data-phase={phase}
				>
					{notification.type === "warning" && (
						<Warning20Regular className={styles.icon} aria-hidden="true" />
					)}
					{notification.type === "error" && (
						<ErrorCircle20Regular className={styles.icon} aria-hidden="true" />
					)}
					<div className={styles.message}>{notification.message}</div>
				</div>
			)}
		</div>,
		document.body,
	);
};
